<div class="col-md-12 col-xs-12"  [formGroup]="form">
    <hr>
    <label>{{'assistance-form.profession'| translate}}</label>
    <div formArrayName="myProfession" *ngFor="let item of myProfession.controls; let i = index;">
        <div class="controls-group"[formGroupName]="i">

            <div class="row ">

                <div class="col-md-1 col-xs-1">
                    <label> </label>
                    <div class="input-group">
                        <button class="btn icon" (click)="removeMyProfessionItem(i)">X</button>
                    </div>
                </div>

                <div class="col-md-5 col-xs-11">
                    <label>
                        {{'assistance-form.subject-field'| translate}}
                    </label>
                    <div class="input-group">
                        <select class="form-control" formControlName="subjectField" id="{{'subjectField' + i}}" (change)="onselect(i)">
                            <option *ngFor="let item of baseService.ThumTaasuka" value="{{item.KOD}}">{{item.TEUR}}</option>
                        </select>


                    </div>
                    <control-messages [control]="f2[i].controls.subjectField"></control-messages>

                </div>
                <div class="col-md-5 col-xs-11">
                    <div *ngIf="required[i]">
                        <label mandatory>
                            {{'assistance-form.subject'| translate}}
                        </label>
                    </div>
                    <div *ngIf="!required[i]">
                        <label>
                            {{'assistance-form.subject'| translate}}
                        </label>
                    </div>
                    <div class="input-group">
                        <select class="form-control" formControlName="subject" id="{{'subject' + i}}" >
                            <option [ngValue]="null" disabled> </option>
                            <option *ngFor="let item of subjectList[i]" value="{{item.KOD}}">{{item.TEUR}}</option>
                        </select>
                    </div>
                    <control-messages [control]="f2[i].controls.subject"></control-messages>

                </div>
            </div>
        </div>
    </div>
    <div class="row controls-group">
        <div class="col-md-12 col-xs-12">
            <div class="input-group">
                <button type="button" class="btn small" (click)="addMyProfessionItem()">{{'add'| translate}}</button>
            </div>
        </div>
    </div>

</div>